// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3BrGC","inner":"Footer_inner__3_V41","nextIcon":"Footer_nextIcon__3xmR4","innerLeft":"Footer_innerLeft__12Jgp"};